import { render, staticRenderFns } from "./ReportTypeFilter.vue?vue&type=template&id=21767616&"
import script from "./ReportTypeFilter.vue?vue&type=script&lang=ts&"
export * from "./ReportTypeFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports